import { withRouter } from 'react-router';
import { Link as RouterLink, NavLink as RouterNavLink } from 'react-router-dom';
import linkFactory from './link';

// Construct the decorated link components
const DecoratedLink = linkFactory(RouterLink);
const DecoratedNavLink = linkFactory(RouterNavLink);

// Wrap the decorated link withRouter HOC
const LinkWithRouter = withRouter(DecoratedLink);
const NavLinkWithRouter = withRouter(DecoratedNavLink);

export default LinkWithRouter;
export { LinkWithRouter as Link, NavLinkWithRouter as NavLink };
